import type { FC } from "react";
import {
	CALCULATOR_ICON_PATHS,
	CALCULATOR_ICON_SIZE,
	CALCULATOR_ICON_STROKE_WIDTH,
	CALCULATOR_ICON_VIEW_BOX,
	type CalculatorIconType,
} from "shared/CalculatorIcons";

type Props = {
	type: CalculatorIconType;
	color: string;
	size?: number;
};

export const CalculatorIcon: FC<Props> = ({
	type,
	color,
	size = CALCULATOR_ICON_SIZE,
}) => (
	<svg
		width={size}
		height={size}
		viewBox={CALCULATOR_ICON_VIEW_BOX}
		fill="none"
		role="presentation"
	>
		{CALCULATOR_ICON_PATHS[type].map((d) => (
			<path
				key={d}
				d={d}
				stroke={color}
				strokeWidth={CALCULATOR_ICON_STROKE_WIDTH}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		))}
	</svg>
);
